import libConstants from '../../constants';
import constants from './constants';
import { getValidProp } from '../../../../../utils/cleanValidateStringPropValue';
import computeClassName from '../../../../../utils/computeClassName';
import ProcessingIndicator from '../../../../PartnerFinderApp/ProcessingIndicator';
import CCFormInputLabel from './_Label';
import CCFormInputInput from './_Input';
import CCFormInputCaption from './_Caption';

const propsDefaults = Object.freeze({
  type: constants.TYPE_DEFAULT,
  size: constants.SIZE_DEFAULT,
  clickFn: null,
  clickFnArgs: undefined,
  isInline: false,
  isDisabled: false,
  hasError: false,
  isProcessingInProgress: false,
  leftSideComponent: null,
  rightSideComponent: null,
  changeFn: null,
  focusFn: null,
  blueFn: null
});

function getValidType(propsType) {
  return getValidProp(propsType,'type',constants.TYPE_DEFAULT, constants.TYPES, constants.COMPONENT_NAME, libConstants.LIB_DEBUG_LOGGER);
}

function getValidSize(propsSize) {
  return getValidProp(propsSize,'size',constants.SIZE_DEFAULT, constants.SIZES, constants.COMPONENT_NAME, libConstants.LIB_DEBUG_LOGGER);
}

function getComputedClassName(propsClassName, size, isInline, isDisabled, hasError) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_INLINE[isInline]} ${constants.CLASSNAME_SIZE[size]} ${constants.CLASSNAME_IS_DISABLED[isDisabled].HAS_ERROR[hasError]}`);
}
function getComputedLabelBgClassName(bgClassName) {
  return !!bgClassName ? bgClassName : constants.CLASSNAME_LABEL_BG;
}

export default function CCFormInput(
  {
    id,
    name,
    value,
    type = propsDefaults.type,
    size = propsDefaults.size,
    isInline = propsDefaults.isInline,
    isDisabled = propsDefaults.isDisabled,
    hasError = propsDefaults.hasError,
    isProcessingInProgress  = propsDefaults.isProcessingInProgress,

    labelText,
    labelBgClassName,
    placeholderText,
    captionText,

    changeFn = propsDefaults.changeFn,
    focusFn = propsDefaults.focusFn,
    blurFn = propsDefaults.blueFn,

    leftSideComponent = propsDefaults.leftSideComponent,
    rightSideComponent = propsDefaults.rightSideComponent,
    className = '',
  }
  ) {
  const validType = getValidType(type);
  const validSize = getValidSize(size);
  const validIsInline = isInline === true;
  const validIsDisabled = isDisabled === true;
  const validHasError = hasError === true;

  const computedClassName = getComputedClassName(className, validSize, validIsInline, validIsDisabled, validHasError);
  const computedLabelBgClassName = getComputedLabelBgClassName(labelBgClassName);

  const hasLabel = !!labelText && !!labelText.length;
  const hasLeftSideComponent = !!leftSideComponent;
  const hasRightSideComponent = !!rightSideComponent || isProcessingInProgress;
  const hasSideComponent = hasLeftSideComponent || hasRightSideComponent;

  return (
    <label className={computedClassName}>
      {
        hasSideComponent &&
        <span className="flex-grow flex flex-row items-center">
          {
            hasLeftSideComponent &&
            <span className="flex-shrink-0 mr-3">{leftSideComponent}</span>
          }
          {
            hasLabel ?
              <span className="relative flex-grow flex flex-col">
                <CCFormInputInput id={id}
                                  name={name}
                                  type={validType}
                                  value={value}
                                  size={validSize}
                                  placeholderText={placeholderText}
                                  isDisabled={isDisabled}
                                  changeFn={changeFn}
                                  focusFn={focusFn}
                                  blueFn={blurFn}
                                  className=""/>
                <CCFormInputLabel isInputDisabled={isDisabled}
                                  className={computedLabelBgClassName}>{labelText}</CCFormInputLabel>

              </span> :
              <CCFormInputInput id={id}
                                name={name}
                                type={validType}
                                value={value}
                                placeholderText={placeholderText}
                                size={validSize}
                                isDisabled={validIsDisabled}
                                changeFn={changeFn}
                                focusFn={focusFn}
                                blueFn={blurFn}
                                className="flex-grow"/>
          }
          {
            hasRightSideComponent && isProcessingInProgress &&
            <ProcessingIndicator size="medium"/>
          }
          {
            hasRightSideComponent && !isProcessingInProgress &&
            <span className="flex-shrink-0 ml-3">{rightSideComponent}</span>
          }
        </span>
      }
      {
        !hasSideComponent && hasLabel &&
        <span className="relative group flex-grow">
          <CCFormInputInput id={id}
                            name={name}
                            type={type}
                            value={value}
                            placeholderText={placeholderText}
                            isDisabled={validIsDisabled}
                            changeFn={changeFn}
                            focusFn={focusFn}
                            blurFn={blurFn}
                            className=""/>
          <CCFormInputLabel isInputDisabled={validIsDisabled}
                            className={computedLabelBgClassName}>{labelText}</CCFormInputLabel>
        </span>
      }
      {
        !hasSideComponent && !hasLabel &&
        <CCFormInputInput id={id}
                          name={name}
                          type={type}
                          value={value}
                          placeholderText={placeholderText}
                          isDisabled={validIsDisabled}
                          changeFn={changeFn}
                          focusFn={focusFn}
                          blurFn={blurFn}
                          className="flex-grow"/>

      }
      {
        !!captionText &&
        <CCFormInputCaption isInputDisabled={validIsDisabled}>{captionText}</CCFormInputCaption>
      }
    </label>
  );
}
